import { useCallback } from 'react';
import { useAxios } from '../axios';
import { GetProductGroupParams, ProductGroup } from './productGroup.types';

export const useGetProductGroup = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: ProductGroup[]; count: number };
  }>({
    method: 'GET',
  });

  const getProductGroup = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
    }: GetProductGroupParams) =>
      axiosFetch({
        url: '/productgroup',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getProductGroup,
  };
};
